export function isOpsPilotPathAllowed(pathname: string): boolean {
  const normalizedPath =
    pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  return (
    normalizedPath === "/pickup_orders" ||
    normalizedPath === "/pickup_orders/create" ||
    normalizedPath === "/knowledge-base" ||
    normalizedPath.startsWith("/knowledge-base/")
  );
}

export function canMutateOpsPickupOrder(
  isPilot: boolean,
  hasWritePermission: boolean,
): boolean {
  return !isPilot && hasWritePermission;
}
